<div class="mx-4 font-sans">
	<section>
		<h1 class="my-8 text-4xl font-bold">Notices</h1>
		<div class="mb-8 flex divide-x divide-solid">
			<a href="/policies/privacy" class="link pr-4">Privacy Policy</a>
			<a href="/policies/terms" class="link px-4">Terms of Service</a>
			<a href="/policies/cookies" class="link px-4">Cookies</a>
		</div>
	</section>
	<hr class="mb-8" />
	<slot />
</div>
